<template>
  <div>
    <div
      v-for="student in students"
      :key="student.id"
      class="student-item p-3 cursor-grab mb-2"
      draggable="true"
      @dragstart="($event) => dragStart(student, $event)"
    >
      {{ student.name }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'AssessmentConfigStudentItemView',
  props: {
    students: {
      type: Array,
      required: true,
    },
    eventId: {
      type: String,
      required: false,
      default: null,
    },
  },
  methods: {
    dragStart (student, event) {
      const payload = {
        studentId: student.id,
        eventId: this.eventId,
      }
      event.dataTransfer.setData('text/plain', JSON.stringify(payload))
    },
  },
}
</script>

<style scoped lang="scss">
.student-item {
  background: white;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  //background: #86BEDA;
  //border-color: #007AA2;
  //border-style: solid;
  //border-radius: 0.375rem;
  //border-width: 2px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
</style>
